/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";

export class CreepyCarnivalTwoBigWinCountUp extends BaseView {

    protected _countUp:BitmapCountUp;
    protected _countUp_2:BitmapCountUp;
    protected _countUp_3:BitmapCountUp;
    protected _countUp_5:BitmapCountUp;
    protected _countUpContainer:PIXI.Sprite;
    private _multiplier:number;
    private _totalwin:number;
    private _singleWin:number;

    public abort(endValue:number, isAborted:boolean):Timeline | null {
        const timeline:TimelineLite = new TimelineLite();

        if(isAborted) {
            timeline.add(this.getAbortAnimation(endValue));
        } else {
            timeline.add(this.getEndingAnimation(endValue));
        }

        return timeline;
    }

    public getCountUpAnimation(from:number, to:number, duration:number, multiplier:number, totalwin:number, _singleWin:number):Timeline {
        this._multiplier = multiplier;
        this._totalwin = totalwin;
        this._singleWin = _singleWin;
        if(multiplier === 2) {
            return this.getCountUpFont(from, to, duration, this._countUp_2);
        } else if(multiplier === 3) {
            return this.getCountUpFont(from, to, duration, this._countUp_3);
        } else if(multiplier === 5) {
            return this.getCountUpFont(from, to, duration, this._countUp_5);
        }
        return this.getCountUpFont(from, to, duration, this._countUp);
    }

    public getEndingAnimation(endValue:number):Timeline {
        if(this._multiplier === 2) {
            return this.getEndFont(endValue, this._countUp_2);
        } else if(this._multiplier === 3) {
            return this.getEndFont(endValue, this._countUp_3);
        } else if(this._multiplier === 5) {
            return this.getEndFont(endValue, this._countUp_5);
        }
        return this.getEndFont(endValue, this._countUp);
    }

    private getEndFont(endValue:number, font:BitmapCountUp):Timeline {
        const timeline:TimelineLite = new TimelineLite();

        timeline.add(font.getCountUpAnimation(endValue, endValue, {duration : 0.01}));
        timeline.add(TweenLite.to(font, 0.5, {alpha : 0, delay : 0.5})); // stay a while after count up.

        return timeline;
    }

    protected initAnimations():void {
        this._countUp = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x1",
                    size : 16
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp_2 = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x2",
                    size : 16
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp_3 = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x3",
                    size : 16
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp_5 = new BitmapCountUp({
            style : {
                font : {
                    name : "creepy_font_x5",
                    size : 16
                },
                align : "center",
                tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
            },
            onWidthChangeCallback : () => {
            }
        });
        this._countUp.shrinkSize = true;
        this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp.visible = false;
        this._countUp.anchor = new PIXI.Point(0, -1.75);

        this._countUp_2.shrinkSize = true;
        this._countUp_2.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp_2.visible = false;
        this._countUp_2.anchor = new PIXI.Point(0, -1.75);

        this._countUp_3.shrinkSize = true;
        this._countUp_3.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp_3.visible = false;
        this._countUp_3.anchor = new PIXI.Point(0, -1.75);

        this._countUp_5.shrinkSize = true;
        this._countUp_5.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._countUp_5.visible = false;
        this._countUp_5.anchor = new PIXI.Point(0, -1.75);

        // To use an extra container to make scale animations. the countUp has it's own scale calculation in animationConfig.
        this._countUpContainer = new PIXI.Sprite();
        this._countUpContainer.anchor.set(0.5, 0.5);
        this._countUpContainer.addChild(this._countUp);
        this._countUpContainer.addChild(this._countUp_2);
        this._countUpContainer.addChild(this._countUp_3);
        this._countUpContainer.addChild(this._countUp_5);

        this.addChild(this._countUpContainer);
    }

    protected getAbortAnimation(endValue:number):Timeline {
        if(this._multiplier === 2) {
            return this.getAbortFont(endValue, this._countUp_2);
        } else if(this._multiplier === 3) {
            return this.getAbortFont(endValue, this._countUp_3);
        } else if(this._multiplier === 5) {
            return this.getAbortFont(endValue, this._countUp_5);
        }
        return this.getAbortFont(endValue, this._countUp);
    }

    private getAbortFont(endValue:number, font:BitmapCountUp):Timeline {
        const timeline:TimelineLite = new TimelineLite();

        timeline.add([
            () => {
                font.alpha = 1;
                font.visible = true;
            },
            () => this._countUpContainer.scale.set(1.0, 1.0),
            TweenLite.to(font, 0.5, {alpha : 0, delay : 0.5}),
            font.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ], GameSetting.isFastSpin ? 0.05 : 0); // added the delay to fix #230

        return timeline;
    }

    private getCountUpFont(from:number, to:number, duration:number, font:BitmapCountUp):Timeline {
        let previousWins = this._totalwin - this._singleWin; //adding the previous wins in totalWin

        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                font.alpha = 1;
                font.visible = true;
            },
            font.getCountUpAnimation(from, to, {
                duration : duration,
                ease : from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }
            ),

        ], GameSetting.isFastSpin ? 0.05 : 0); // added the delay to fix #230

        if(to + previousWins === this._totalwin) { //will update the counter at the end
            timeline.add(() => SlotGame.winFieldController.showWinField(to + previousWins), duration);
        }
        return timeline;
    }
}